import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=ff4c544e"
import script from "./authentication.vue?vue&type=script&lang=js"
export * from "./authentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports